import locale from "../../../locale";
import { translateLabel } from "./tools";
import * as constants from "./constants";

export const participationTypes = {
    online: locale('participationType.online'),
    offline: locale('participationType.offline'),
};

export const defaultTableFields = [
	{
		label: locale('table.email'),
		name: 'email',
	},
	{
		label: locale('table.name'),
		name: 'name',
	},
	{
		label: locale('participationType'),
		name: 'participationType',
	},
	{
		label: locale('table.registrationDate'),
		name: 'registrationDate',
	},
	{
		label: locale('role.label'),
		name: 'role',
	},
];

export const eventRegistrationRoleOptions = [
	{
		value: constants.ROLE_VIEWER,
		label: translateLabel('role', constants.ROLE_VIEWER),
	},
	{
		value: constants.ROLE_MODERATOR,
		label: translateLabel('role', constants.ROLE_MODERATOR),
	},
	{
		value: constants.ROLE_ORGANIZER,
		label: translateLabel('role', constants.ROLE_ORGANIZER),
	},
	{
		value: constants.ROLE_SPEAKER,
		label: translateLabel('role', constants.ROLE_SPEAKER),
	},
	{
		value: constants.ROLE_TECHNICAL_SUPPORT,
		label: translateLabel('role', constants.ROLE_TECHNICAL_SUPPORT),
	},
];

export const eventRegistrationStatusOptions = [
	{
		value: constants.STATUS_APPROVED,
		label: translateLabel('status', constants.STATUS_APPROVED),
	},
	{
		value: constants.STATUS_REQUEST,
		label: translateLabel('status', constants.STATUS_REQUEST),
	},
	{
		value: constants.STATUS_REJECT,
		label: translateLabel('status', constants.STATUS_REJECT),
	},
];

export const konturFocusFields = [
	{
		name: 'organizationName',
		type: 'organization',
		label: 'Название организации',
	},
	{
		name: 'organizationInn',
		type: 'number',
		label: 'ИНН',
	},
	{
		name: 'organizationKpp',
		type: 'number',
		label: 'КПП',
	},
];

export const uploadPhotoRequirements = {
    [constants.REQUIREMENT_FORMAT] : "registration.addPhoto.requirements.format",
    [constants.REQUIREMENT_SIZE] : "registration.addPhoto.requirements.size",
    [constants.REQUIREMENT_WEIGHT] : "registration.addPhoto.requirements.weight",
    [constants.REQUIREMENT_FACE] : "registration.addPhoto.requirements.face",
    [constants.REQUIREMENT_ACCESSORIES] : "registration.addPhoto.requirements.accessories",
};

export const checkboxFieldOptions = [
	{
		value: '',
		label: 'Все',
	},
	{
		value: true,
		label: 'Да',
	},
	{
		value: false,
		label: 'Нет',
	},
];

export const photoValidField = {
    name: 'photoValid',
    type: 'checkbox',
    label: 'Фото прошло проверку'
};
